module.exports = __webpack_public_path__ + "static/media/distance_vertical_icon.1cfa3189.svg";